import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'any',
})
export class FreeServicesRequestListService {
  geomPointFromMap = new Subject<string>();
}
